import React from 'react';
var SiteLogo = function SiteLogo(_ref) { var className = _ref.className; return /*#__PURE__*/ React.createElement("img", { src: "/images/logo.svg", className: className, alt: "Logo of Arthur's Portfolio", width: 407, height: 127 }); };
export default SiteLogo;
